var map = {
	"./icon-add-friend.svg": 9559,
	"./icon-add-to-group.svg": 11822,
	"./icon-alert.svg": 20017,
	"./icon-bell.svg": 562,
	"./icon-bin.svg": 40044,
	"./icon-captain.svg": 95723,
	"./icon-casual-arrow.svg": 65630,
	"./icon-challenge-outline.svg": 78945,
	"./icon-challenge.svg": 8944,
	"./icon-chat.svg": 69947,
	"./icon-check-circle.svg": 48232,
	"./icon-chevron-down.svg": 20455,
	"./icon-cloud-upload.svg": 13874,
	"./icon-cog-solid.svg": 68796,
	"./icon-comment-dots.svg": 91689,
	"./icon-create-contest.svg": 2782,
	"./icon-cross-circle.svg": 25108,
	"./icon-cross.svg": 39351,
	"./icon-drop1.svg": 83919,
	"./icon-edit.svg": 15761,
	"./icon-email.svg": 98631,
	"./icon-export.svg": 67303,
	"./icon-file.svg": 90603,
	"./icon-friend-card.svg": 17312,
	"./icon-friend-rainbow.svg": 19308,
	"./icon-friend.svg": 36993,
	"./icon-glasses.svg": 12459,
	"./icon-golf-hole.svg": 18428,
	"./icon-group.svg": 37154,
	"./icon-h2h.svg": 41157,
	"./icon-import.svg": 67754,
	"./icon-invisible.svg": 28834,
	"./icon-invite-friend.svg": 47159,
	"./icon-jersey.svg": 73801,
	"./icon-leaderboard.svg": 66230,
	"./icon-left-arrow.svg": 95366,
	"./icon-link.svg": 66545,
	"./icon-menu-bonus.svg": 44742,
	"./icon-minus-ios.svg": 23359,
	"./icon-minus.svg": 76207,
	"./icon-moon.svg": 81778,
	"./icon-more-horizontal.svg": 62659,
	"./icon-more-vertical.svg": 48025,
	"./icon-multientry.svg": 46396,
	"./icon-one-square.svg": 92493,
	"./icon-parks.svg": 74168,
	"./icon-payout-guaranteed-plus.svg": 29723,
	"./icon-payout-guaranteed.svg": 81986,
	"./icon-payout-x10.svg": 991,
	"./icon-payout-x2.svg": 63494,
	"./icon-payout-x3.svg": 73412,
	"./icon-payout-x5.svg": 66089,
	"./icon-pending.svg": 48730,
	"./icon-plus-circle.svg": 47230,
	"./icon-plus-ios.svg": 16833,
	"./icon-plus.svg": 90689,
	"./icon-progress-bar.svg": 76200,
	"./icon-pyramid-chart.svg": 35188,
	"./icon-refresh.svg": 57406,
	"./icon-remove-friend.svg": 7122,
	"./icon-remove-from-group.svg": 11952,
	"./icon-right-arrow.svg": 74285,
	"./icon-search.svg": 23197,
	"./icon-shopping-cart.svg": 33564,
	"./icon-shrink.svg": 29102,
	"./icon-social-facebook.svg": 64777,
	"./icon-social-instagram.svg": 82587,
	"./icon-social-twitter.svg": 72134,
	"./icon-sort.svg": 15269,
	"./icon-spartan.svg": 40902,
	"./icon-sport-all.svg": 7487,
	"./icon-sport-american-football.svg": 64406,
	"./icon-sport-australian-football.svg": 34760,
	"./icon-sport-baseball.svg": 33994,
	"./icon-sport-basketball.svg": 92059,
	"./icon-sport-cricket.svg": 38843,
	"./icon-sport-esports.svg": 41210,
	"./icon-sport-f1.svg": 93761,
	"./icon-sport-golf.svg": 28038,
	"./icon-sport-greyhound.svg": 61259,
	"./icon-sport-horse.svg": 55401,
	"./icon-sport-ice-hockey.svg": 38915,
	"./icon-sport-kabaddi.svg": 78778,
	"./icon-sport-mlb.svg": 21101,
	"./icon-sport-rugby-league.svg": 50267,
	"./icon-sport-soccer.svg": 69043,
	"./icon-star.svg": 50785,
	"./icon-target.svg": 92894,
	"./icon-tick-circle.svg": 40183,
	"./icon-tick.svg": 88330,
	"./icon-toggle-on.svg": 90097,
	"./icon-training.svg": 43851,
	"./icon-trophy.svg": 98995,
	"./icon-user-h2h.svg": 41393,
	"./icon-user.svg": 24364,
	"./icon_download.svg": 99043,
	"./icon_menu_about.svg": 30236,
	"./icon_menu_contact.svg": 28755,
	"./icon_menu_corporate_website.svg": 97504,
	"./icon_menu_draftstars_coach.svg": 99058,
	"./icon_menu_faqs.svg": 47686,
	"./icon_menu_friends.svg": 76768,
	"./icon_menu_gamble_responsibly.svg": 38160,
	"./icon_menu_gift.svg": 81259,
	"./icon_menu_gift_store.svg": 27209,
	"./icon_menu_history.svg": 1739,
	"./icon_menu_how_to_play.svg": 95152,
	"./icon_menu_live_now.svg": 44618,
	"./icon_menu_lobby.svg": 59911,
	"./icon_menu_my_challenges.svg": 77924,
	"./icon_menu_my_teams.svg": 13476,
	"./icon_menu_news.svg": 48052,
	"./icon_menu_playup.svg": 7160,
	"./icon_menu_privacy_policy.svg": 80244,
	"./icon_menu_rapidfire.svg": 7781,
	"./icon_menu_rules.svg": 71426,
	"./icon_menu_terms_conditions.svg": 48595,
	"./icon_menu_training_ground.svg": 10223,
	"./icon_menu_ultimate_champion.svg": 52826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6737;